// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uZAn","label":"styles_label__3oid1"};